import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import warning from "../../../assets/warning.svg";
import styles from "./idle-session-modal-content.module.scss";
import {IDLE_SESSION} from "../../../helpr/constants";

/*
 Idle Session Modal Content
 */
const IdleSessionModalContent = ({onClose}) => {
  const message = IDLE_SESSION;
  return (
    <div className={styles['idle-session-modal-content']}>
      <Row>
        <Col lg={12}>
          <div>
            <img className={styles['img']} alt="Success" src={warning} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['message']}>
            <p>{message}</p>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col lg={12}>
          <div className={styles['ok-button']}>
            <Button onClick={() => onClose()}>
              OK
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default IdleSessionModalContent;
